import { ToastState } from '@ordermentum/ui-definitions';
import C from '../constants';

export default (state: ToastState[] = [], action) => {
  switch (action.type) {
    case C.SHOW_TOAST: {
      const {
        notificationPayload,
        notificationTitle,
        id,
        notificationDelay,
        notificationType,
        permalink,
      } = action;
      return [
        ...state,
        {
          id,
          notificationTitle,
          notificationPayload,
          notificationDelay,
          notificationType,
          permalink,
          hidden: 'show',
        },
      ];
    }
    case C.HIDE_TOAST: {
      const notification = state.find(n => n.id === action.id);
      if (!notification) return state;
      notification.hidden = 'hide';
      const withoutNotification = state
        .filter(n => n.id !== action.id)
        .map(n => (n.hidden === 'show' ? { ...n, hidden: 'shown' } : n));
      return [notification, ...withoutNotification]
        .filter(n => !!n)
        .sort(
          (prev, next) =>
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            new Date(prev.notificationPayload?.createdAt ?? null).getTime() -
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            new Date(next.notificationPayload?.createdAt ?? null).getTime()
        );
    }
    case C.REMOVE_TOAST: {
      return state.filter(n => n.id !== action.id);
    }
    default:
      return state;
  }
};
